import { PublicClientApplication } from '@azure/msal-browser'

/** The B2C settings each API serves at `/api/clientconfig`, so one build works in every environment. */
export type ClientConfig = {
  clientId: string
  authority: string
  knownAuthorities?: string[]
  redirectUri: string
  apiScopes: string[]
}

// Native fetch, not an app's API client: that client attaches tokens through MSAL, which can't
// exist until this config has loaded. The endpoint is public.
export async function fetchClientConfig(): Promise<ClientConfig> {
  const res = await fetch('/api/clientconfig')
  if (!res.ok) throw new Error(`Failed to load app config: ${res.status}`)
  return res.json()
}

/** Creates the MSAL instance. The caller awaits `initialize()`, which handles a B2C redirect. */
export function createMsal(
  config: ClientConfig,
  cacheLocation: 'sessionStorage' | 'localStorage',
): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      knownAuthorities: config.knownAuthorities,
      redirectUri: config.redirectUri,
    },
    cache: { cacheLocation },
  })
}
